<!-- 选择门店item -->
<template>
  <div class="store-item">
    <!-- <van-checkbox v-model="storeInfo.checked"></van-checkbox> -->
    <div class="store-info" :class="{'active':storeInfo.checked}" @click.stop="chooseStore">
      <div class="store-name">{{storeInfo.StoreName}}（{{storeInfo.ChildAccountNum}}/{{storeInfo.MaxChildAccountNum}}）</div>
      <div class="store-address">{{storeInfo.Address}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddChildAccountStoreItem',
  mixins: [],
  components: {},
  // 数据部分
  props: {
    storeInfo: {
      type: Object,
      default: () => { }
    },
    maxSubCount:{
      type:[String, Number],
      default:3
    }
  },
  data() {
    return {
      checked: true
    };
  },
  computed: {},
  watch: {},
  // 生命周期
  created() { },
  mounted() { },
  unmounted() { },
  // 方法
  methods: {
    chooseStore(){
      const {maxSubCount,storeInfo:{ChildAccountNum, checked: oldChecked},storeInfo } = this
      if(ChildAccountNum >= maxSubCount && !storeInfo.checked){
        this.$toast({ message: '该门店子账号数已满' })
      }else{
        storeInfo.checked=!storeInfo.checked
        storeInfo.ChildAccountNum = oldChecked ? storeInfo.ChildAccountNum - 1 : storeInfo.ChildAccountNum + 1
      }
    }
  },
};
</script>
<style lang="less" scoped>
.store-item {
  display: flex;
  margin-bottom: 12px;
  text-align: left;
  width: 400px;
  .store-info {
    cursor: pointer;
    flex: 1;
    height: 62px;
    background: #f9fafb;
    border-radius:4px;
    border:1px solid #dfe1e8;
    color: #111a34;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left:12px;
    transition: all .5s;
    &.active{
      border-color: #0F6EEA;
      background: #E1EEFF;
      transition: all .5s;
    }
    .store-name {
    }
    .store-address {
      font-size:12px;
      color: #666f83;
    }
  }
}
</style>